import React, { useState, useEffect } from "react";
import TopNav from "../layouts/TopNav";
import "../Styles/invoiceTable.css";
import { FiRefreshCcw } from "react-icons/fi";
import TablePagination from "@mui/material/TablePagination";
import { BsSearch } from "react-icons/bs";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ReLoginModal from "../components/ReLoginModal";
import api from "../util/axios";

export type Price = {
  name: string;
  description: string;
  unitOfMeasure: string;
  category: string;
  price: any;
  newSellingPrice: string;
  previousSellingPrice: string;
  details: any;
  role: string;
  updatedAt: string;
  staff: any;
  customer: any;
  customerAccount: any;
  quantity: any;
  amount: any;
};

const Price = () => {
  const [reLogin, setReLogin] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");


  const [selectedCategory, setSelectedCategory] = useState("");

  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");
  const [getPrice, setgetPrice] = useState<Price[]>([]);

  function queryCustomer() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return api
      .get("/inventory/history/price", {
        headers: headers,
      })
      .then((res) => {
        setgetPrice(res.data.data);
      })
      .catch((error) => {
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        toast.error(error.response.data.message);
      });
  }

  useEffect(() => {
    queryCustomer();
  }, []);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onRefresh = () => {
    window.location.reload();
  };
  return (
    <div className="board">
      <ToastContainer />
      <TopNav title="Price Update History" />
      {reLogin ? <ReLoginModal /> : null}
      <div className="product">
        <div className="productBtn" style={{ marginBottom: "1px" }}>
          <button onClick={onRefresh} className="productBtn1">
            <FiRefreshCcw />
            Refresh
          </button>
        </div>
        <div
          className="method"
          style={{ justifyContent: "flex-end", marginTop: 0 }}
        >
          <div className="apInput">
            <input
              type="text"
              value={searchQuery}
              placeholder="Search by name"
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <BsSearch className="apIcon" />
          </div>
          {/* <div className="filterBy">
            <p>FilterBy Status</p>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="">Status</option>
              <option value="admin">Admin</option>
              <option value="staff">staff</option>
            </select>
          </div> */}
        </div>
        <div className="invoiceTable">
          <table className="inTable">
            <tr className="heTable">
              <th className="sn">S/N</th>
              <th>Product </th>
              {/* <th>Type</th> */}
              <th>Old Price</th>
              <th>New Price</th>
              <th>Staff</th>
              <th>Date</th>
            </tr>

            {getPrice
              .filter(
                (data) =>
                  data?.details.name
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase()) &&
                  (selectedCategory === "" ||
                    data?.staff.role === selectedCategory)
              )
              .reverse()
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((data, inx) => {
                const dateString = data.updatedAt;
                const formattedDate = new Date(dateString)
                  .toISOString()
                  .split("T")[0];
                return (
                  <tr key={inx} className="taData">
                    <td className="sn">{inx + 1}</td>
                    <td>{data?.details.name}</td>
                    {/* <td>Service</td> */}
                    <td>{data?.details.previousSellingPrice}</td>
                    <td>{data?.details.newSellingPrice}</td>
                    <td>{data.staff.role}</td>
                    <td>{formattedDate}</td>
                  </tr>
                );
              })}
          </table>
        </div>
      </div>
      <TablePagination
        rowsPerPageOptions={[15, 25, 50]}
        component="div"
        count={getPrice.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default Price;
